import { createQueryKeys } from '@lukemorales/query-key-factory';
import { IReqOptions } from 'common/clients/api.client.ts';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import {
  IUserBillingFieldsRes,
  IUserProfileConfigReqData,
  IUserProfileConfigRes,
  IUserProfileDataRes,
  IUserSessionsRes,
  IUserWalletsDataRes,
} from 'domains/user/interfaces/user.interfaces.ts';
import {
  getUserBillingFieldsService,
  getUserProfileConfigService,
  getUserProfileDataService,
  getUserSessionsService,
  postUserProfileConfigService,
  getUserWalletsDataService,
} from 'domains/user/services/user.service.ts';

export const userQueryKeys = createQueryKeys(EQueryKeys.UserKeys, {
  getUserProfileData: () => ({
    queryKey: ['get-user-profile-data'],
    queryFn: (): Promise<IUserProfileDataRes> => getUserProfileDataService(),
  }),
  getUserProfileConfig: ({
    reqOptions,
  }: {
    reqOptions?: IReqOptions;
  }) => ({
    queryKey: ['get-user-profile-config'],
    queryFn: (): Promise<IUserProfileConfigRes> => getUserProfileConfigService({ reqOptions }),
  }),
  postUserProfileConfig: (data: IUserProfileConfigReqData) => ({
    queryKey: ['post-user-profile-config', data],
    queryFn: (): Promise<IUserProfileConfigRes> => postUserProfileConfigService(data),
  }),
  getUserSessions: () => ({
    queryKey: ['get-user-sessions'],
    queryFn: (): Promise<IUserSessionsRes> => getUserSessionsService(),
  }),
  getUserBillingFields: ({
    reqOptions,
  }: {
    reqOptions?: IReqOptions;
  }) => ({
    queryKey: ['get-user-billing-fields'],
    queryFn: (): Promise<IUserBillingFieldsRes> => getUserBillingFieldsService({ reqOptions }),
  }),
  getUserWalletsData: ({
    reqOptions,
  }: {
    reqOptions?: IReqOptions,
  }) => ({
    queryKey: ['get-user-wallets-data'],
    queryFn: (): Promise<IUserWalletsDataRes> => getUserWalletsDataService({ reqOptions }),
  }),
});
